<template>
  <v-container class="page-content px-5" style="width: 100%">
    <OrderDetail
        v-if="!this.loading"
        :item="item"
        :blackListDisabled="true"
    >
      <template v-slot:btn>
        <v-btn

            @click="returnParent()" class="dark-primary pr-0 mr-0" icon small
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if="$vuetify.breakpoint.xsOnly && item.is_agreed === null && item.is_formalized === false"
            icon
            class="mr-0 dark-primary"
            @click="editOrder(item)"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp && item.is_agreed === null && item.is_formalized === false">
          <v-btn
              text
              @click="editOrder"
              class="rounded-tr-lg dark-primary"
          >
            Редактировать заявку
          </v-btn>
        </v-toolbar-items>
      </template>
    </OrderDetail>
    <v-skeleton-loader
        v-else
        type="table-heading, list-item-three-line, image, list-item-two-line, table-tfoot"
    ></v-skeleton-loader>
    <ApplyDialog
            v-if="dialog_status"
            :opened="dialog_status"
            :get-text="() => dialog_status_text"
            @close="closeStatusDialog"
    ></ApplyDialog>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :order-data="item"
        @close="closeEditDialog"
    ></EditDialog>
    <v-dialog
            v-model="error_text.error"
            transition="dialog-top-transition"
            max-width="500"
    >
        <v-card>
            <v-card-title class="text-h5 red lighten-2 mt-n2">
                <span class="white--text">Ошибка</span>
            </v-card-title>
            <v-card-text class="subtitle-1 mt-4 text--primary text-left">
                {{ error_text.text }}
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn
                        text
                        @click="error_text.error = false"
                >Закрыть</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import TitledPageMixin from "@/mixins/TitledPageMixin";
import EditDialog from "@/modules/representative/orders/components/OrdersEditDialog";
import {mapActions, mapGetters} from "vuex";
import names from "@/modules/representative/routers/names";
import OrderDetail from "@/modules/templates/OrderDetail";
import ApplyDialog from "@/modules/core/components/ApplyDialog";
import representative from "@/urls/roles/representative";
import names_core from "@/modules/core/routers/names";

export default {
  name: "RepresentativeOrdersDetail",
  mixins: [TitledPageMixin],
  components: {EditDialog, OrderDetail, ApplyDialog},
  data() {
    return {
      loading: true,
      page_title: "Детальное представление заявки",
      dialog_add_edit: false,
      edit_status: undefined,
      dialog_status: false,
      dialog_status_text: "",
      order_data: undefined,
      error_text: {
          error: false,
          text: ""
      },
      need_reload: undefined
    }
  },
  computed: {
    ...mapGetters({
      item: "representative/getOrdersDetail"
    })
  },
  methods: {
    ...mapActions({
      loadOrderDetail: "representative/loadOrdersDetail",
      formalizeOrders: "representative/formalizeOrders"
    }),
    returnParent() {
      this.$router.push({name: names.ORDERS.LIST, query: {need_reload: this.need_reload}}).catch(() => {})
    },
    loadData(url=undefined){
      this.loadOrderDetail({
        url: url,
        id: this.$route.params.idOrders,
        finalizer: (data) => {
          if (data.through_number === null) {
            this.page_title = "Черновик заявки"
          } else {
            this.page_title = "Заявка: " + data.through_number
          }
          this.loading = false
          // Проверка query параметра, при загрузке детали, для моментального открытия формы редактирования
          if (this.$route.query.edit && data.is_agreed === null && data.is_formalized === false) {
            this.editOrder()
          }
        }
      })
    },
    editOrder() {
      this.dialog_add_edit = true
      this.edit_status = true
      this.order_data = this.item
    },
    closeStatusDialog(event) {
      if(event) {
          this.formalizeOrders({
              id: this.order_data.id,
              data: { "is_formalized": true },
              finalizer: (val) => {
                  this.loadData()
                  this.need_reload = true
                  // Очистка query параметра при закрытии формы редактирования
                  if (this.$route.query.edit) {
                    this.$router.replace({name: names.ORDERS.LIST,"query": null})
                  }
              },
              catcher:(val) => {
                  this.error_text.error = true
                  this.error_text.text = String(val.detail)
              }
          })
      }
      this.dialog_add_edit = false
      if (this.order_data.order_type === 1 && !event || this.order_data.order_type === 4 && !event) {
          this.loadData()
          this.dialog_add_edit = false
          if (this.$route.query.edit) {
            this.$router.replace({name: names.ORDERS.LIST,"query": null})
          }
      }
      this.dialog_status = false
      this.order_data = undefined
    },
    changeOrderStatus(item) {
        this.dialog_status_text = this.checkEditFlag(item).form
        this.dialog_status = true
        this.order_data = item
    },
    checkEditFlag() {
        return {icon: "redo", text: "Отправить на согласование", form: "Вы уверены, что хотите сформировать данную заявку и отправить ее на согласование?"}
    },
    closeEditDialog(event) {
        if (event.order_type === 1 || event.order_type === 4) {
            this.changeOrderStatus(event)
        } else {
            this.loadData()
            this.dialog_add_edit = false
            this.edit_status = undefined
            this.order_data = undefined
            // Очистка query параметра при закрытии формы редактирования
            if (this.$route.query.edit) {
              this.$router.replace({name: names.ORDERS.LIST,"query": null})
            }
        }
    }
  },
  created () {
    if(representative.REPRESENTATIVE.ALLOWED()) {
      this.loadData(undefined)
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
